import { useLocation } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Fade, Stack, styled, Typography } from '@mui/material';

import { userInfoAtom } from '@/interfaces/member';
import { tempUnitAtom, timeZoneAtom } from '@/interfaces/utils';
import { SettingLayout } from '@/components/setting/SettingLayout';
import ProfileInformation from '@/components/setting/users/ProfileInformation';

const Section = styled(Stack)`
  background: #ffffff;
  margin-bottom: 1rem;
  border-radius: 12px;
  padding: 1rem;
`;

export default function Users() {
  const { data: userData } = useAtomValue(userInfoAtom);
  const tz = useAtomValue(timeZoneAtom);
  const tempUnit = useAtomValue(tempUnitAtom);

  const location = useLocation();
  const { i18n } = useTranslation();

  return (
    <Fade in={location.pathname === '/setting/users'}>
      <SettingLayout>
        <Section gap={2} alignItems="center" direction="row">
          <img src="/images/common/avatar-demo.png" alt="avatar" />
          <Stack>
            <Typography>{userData && userData.name}</Typography>
            <Typography fontSize={'small'}>{userData && userData.email}</Typography>
          </Stack>
        </Section>
        {userData && (
          <Section gap={3} alignItems="flex-start">
            <ProfileInformation
              name={userData.name}
              email={userData.email}
              language={i18n.language}
              tz={tz}
              tempUnit={tempUnit}
            />
          </Section>
        )}
      </SettingLayout>
    </Fade>
  );
}
